module.exports = __webpack_public_path__ + "img/questionnaire.c575fb15.svg";